var map = {
	"./alerts.json": "./src/locales/en/alerts.json",
	"./changelogs.json": "./src/locales/en/changelogs.json",
	"./common.json": "./src/locales/en/common.json",
	"./csv.json": "./src/locales/en/csv.json",
	"./custom.json": "./src/locales/en/custom.json",
	"./dashboards.json": "./src/locales/en/dashboards.json",
	"./data_types.json": "./src/locales/en/data_types.json",
	"./descriptions.json": "./src/locales/en/descriptions.json",
	"./devices.json": "./src/locales/en/devices.json",
	"./documents.json": "./src/locales/en/documents.json",
	"./errors.json": "./src/locales/en/errors.json",
	"./export.json": "./src/locales/en/export.json",
	"./forms.json": "./src/locales/en/forms.json",
	"./graphs.json": "./src/locales/en/graphs.json",
	"./groups.json": "./src/locales/en/groups.json",
	"./highcharts.json": "./src/locales/en/highcharts.json",
	"./logs.json": "./src/locales/en/logs.json",
	"./messaging.json": "./src/locales/en/messaging.json",
	"./notifications.json": "./src/locales/en/notifications.json",
	"./passages.json": "./src/locales/en/passages.json",
	"./rounds.json": "./src/locales/en/rounds.json",
	"./search.json": "./src/locales/en/search.json",
	"./settings.json": "./src/locales/en/settings.json",
	"./subscriptions.json": "./src/locales/en/subscriptions.json",
	"./tickets.json": "./src/locales/en/tickets.json",
	"./users.json": "./src/locales/en/users.json",
	"./workspace.json": "./src/locales/en/workspace.json",
	"./workspaces.json": "./src/locales/en/workspaces.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locales/en sync recursive ^\\.\\/.*\\.json$";